import { ReactNode, useState } from 'react'

import { cn } from '@/lib'

const Collapse = ({
  children,
  maxHeight,
  isExpanded,
  trigger,
  className,
  expandClassName,
}: {
  children: ReactNode
  maxHeight: string
  isExpanded: boolean
  trigger?: ReactNode
  className?: string
  expandClassName?: string
}) => {
  const [isAnimating, setIsAnimating] = useState(false)

  const handleTransitionEnd = () => {
    setIsAnimating(false)
  }
  return (
    <div>
      <div
        onClick={() => {
          setIsAnimating(true)
        }}
      >
        {trigger}
      </div>
      <div
        style={{ maxHeight: isExpanded ? maxHeight : '0' }}
        className={cn(
          'transition-all duration-300 ease-in-out',
          isAnimating || !isExpanded ? 'overflow-hidden' : 'overflow-visible',
          className,
          isExpanded ? expandClassName : ''
        )}
        onTransitionEnd={handleTransitionEnd}
      >
        {children}
      </div>
    </div>
  )
}
export default Collapse
